module.exports = __webpack_public_path__ + "static/how-to-create-brand__step-2-8e35f38043b0d484e02b96379c048d51.png";